"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageSessionRefreshTimer = void 0;
var refreshTokenExpirationKey = 'refreshTokenExpiration';
function isExpired(expiration) {
    return Date.now() > expiration;
}
var LocalStorageSessionRefreshTimer = /** @class */ (function () {
    function LocalStorageSessionRefreshTimer(localStorage, ttl) {
        this.localStorage = localStorage;
        this.ttl = ttl;
    }
    LocalStorageSessionRefreshTimer.prototype.reset = function () {
        this.localStorage.setItem(refreshTokenExpirationKey, JSON.stringify(Date.now() + this.ttl));
    };
    LocalStorageSessionRefreshTimer.prototype.shouldRefreshSession = function () {
        var refreshTokenExpiration = this.localStorage.getItem(refreshTokenExpirationKey);
        return !refreshTokenExpiration || isExpired(JSON.parse(refreshTokenExpiration));
    };
    return LocalStorageSessionRefreshTimer;
}());
exports.LocalStorageSessionRefreshTimer = LocalStorageSessionRefreshTimer;
//# sourceMappingURL=localStorageSessionRefreshTimer.js.map